import * as React from 'react';
import { StyleSheet, css } from 'aphrodite';
export var Spinner = function (props) {
    return (React.createElement("svg", { viewBox: "0 0 150 150", className: css(styles.loadingWrapper) },
        React.createElement("circle", { r: "60", cx: "75", cy: "75", className: css(styles.spinner) })));
};
var dash = {
    to: {
        strokeDashoffset: 0,
    },
    from: {
        strokeDashoffset: 600
    }
};
var styles = StyleSheet.create({
    loadingWrapper: {
        width: '32px',
        height: '32px',
        animation: 'fa-spin 3s linear 0s infinite'
    },
    spinner: {
        strokeWidth: '12',
        strokeDasharray: '300',
        strokeLinecap: 'round',
        strokeMiterlimit: '10',
        stroke: 'rgb(0, 0, 50)',
        fill: 'none',
        animationName: [dash],
        animationDuration: '1.6s',
        animationTimingFunction: 'cubic-bezier(0.4, 0.15, 0.6, 0.85)',
        animationSelay: '0s',
        animationIterationCount: 'infinite',
    },
});



//////////////////
// WEBPACK FOOTER
// ./node_modules/@trustpilot/ecommscript-integrationappauth/dist/CommonUI/Components/Spinner.js
// module id = 1355
// module chunks = 0